import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RptIdService {

  constructor(private http: HttpClient) { }

  getRptOptions(docType : any): Observable<any> {
    const url = `${environment.logisticsApiUrl}/RptId/getRptIdOptions/${docType}`;
    // const url = 'http://127.0.0.1:8081/logistics/RptId'+ `/getRptIdOptions/${docType}`;
    return this.http.get(url);
  }

}
